// extracted by mini-css-extract-plugin
export default {"About3Main":"About3_About3Main__ShFEK","About3Container":"About3_About3Container__bDIFr","About3Parent":"About3_About3Parent__SEjvS"};